export const routes = (parentName) => {
  return [
    {
      path: "webinar",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Webinar`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Webinar-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Webinar-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Webinar-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
